<template>
    <div class="main">
        <div class="main-container">
            <div class="title">
                <h3><em></em><span>Introduction</span><em></em></h3>
            </div>
            <!-- <div class="top">
                <div class="top-title">
                    <p>To be announced</p>
                </div>
                <div class="top-links">
                    <a href="/">To be announced</a>
                    <a href="/">To be announced</a>
                    <a href="/">To be announced</a>
                </div>
            </div> -->
            <div class="main-content">
                <div class="summary">
                    <p>Building upon the success of the inaugural meeting, the second International Conference on Aging
                        and Cancer highlighted major advances in understanding the molecular and cellular mechanisms
                        that connect aging with cancer development. The conference featured internationally recognized
                        experts in cellular senescence, clonal hematopoiesis, somatic mutation, genome maintenance, stem
                        cell biology, telomere biology, tumor microenvironment, and cancer evolution. Discussions
                        focused on how age-associated biological processes influence cancer initiation, progression,
                        metastasis, and therapeutic response, while exploring emerging technologies and innovative
                        approaches for cancer prevention and healthy aging. By fostering collaboration across basic,
                        translational, and clinical research, the conference sought to advance the rapidly evolving
                        field of aging and cancer research.</p>
                </div>
                <div class="content">
                </div>
            </div>

        </div>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()
</script>


<style scoped lang="scss">
@font-face {
    font-family: 'Jost';
    font-style: normal;
    font-display: swap;
    src: url("/public/fonts/92zatbhpnqw73otd4g.woff2") format('woff2');
}

.main {
    padding: 40px 0;
}

.main-container {
    width: 1200px;
    margin: 0 auto;

    .title {
        h3 {
            font-size: 30px;
            font-weight: bold;
            text-align: center;
            color: #303133;
            margin-bottom: 60px;

            span {
                margin: 0 40px;
            }

            em {
                display: inline-block;
                width: 54px;
                height: 14px;
                margin-bottom: 10px;
                background: url('@/assets/tt.png');
                vertical-align: middle;
            }
        }
    }

    .top {
        width: 100%;
        display: flex;
        flex-direction: row;
        padding: 40px 0;
        margin-bottom: 40px;

        .top-title {
            width: 65%;
            font-size: 35px;
            color: #04425c;
            line-height: 1.2;
            font-family: 'Jost', 'Open Sans', sans-serif;
            font-weight: 400;
            border-right: 1px solid #05425C;
        }

        .top-links {
            width: 35%;
            font-size: 14px;
            margin-left: 20px;

            a {
                margin-bottom: 5px;
                display: block;
                text-decoration: none;
                color: #0E74A3;

                &:hover {
                    color: #05425C;
                }
            }
        }
    }

    .main-content {
        max-width: 90%;
        margin: 0 auto;

        .summary {
            font-size: 22px;
            font-family: 'Jost', 'Open Sans', sans-serif;
            line-height: 35px;
            font-weight: 300;
            margin-bottom: 40px;

        }

        .content {
            p {
                font-size: 18px;
                line-height: 30px;
                margin-bottom: 20px;
            }
        }
    }
}

@media (max-width: 768px) {
    .main-container {
        width: 100%;
        padding: 0 20px;

        .top {
            flex-direction: column;
            padding: 20px 0;
            margin-bottom: 20px;

            .top-title {
                width: 100%;
                font-size: 28px;
                margin-bottom: 20px;
                border-right: none;
            }

            .top-links {
                width: 100%;
                font-size: 14px;
                margin-left: 0;
            }
        }

        .main-content {
            max-width: 100%;
        }
    }
}
</style>
